<template>
    <div>
        <order-set-view
          :callback_compartilhar="compartilhar_order_set"
          :dados="lista_receita"
          :solmatmed="false"
          type="receita"
          @editar="abrir('receita', $event)"
          @imprimir="imprimir_receita"
          @refresh="$emit('refresh')"
          @assinar="assinar"
          :atendimento="atendimento"
          :pep="true"
          :view_only="true"
        />
    </div>
</template>

<script>
import OrderSetView from './OrderSetView.vue';

export default {
    data() {
        return { 

        }
    },

    components: { 
        OrderSetView, 
    }, 

    props: [
        'atendimento',
        'lista_receita',
    ],

    methods: { 
        imprimir_receita(dados) {
            if ( !dados )
                return;


            this.$util.print_preview('imprimir/receita/' + dados.id_receita, true, { noass: 1 }, true);
        },

        assinar (order) {
            this.$emit('assinar', order);
        },

        compartilhar_order_set (order) { 
            this.$emit('compartilhar', order);
        },
    }
}
</script>
